// Digests (§14.1, §19): SHA-256 over a source's original bytes as UTF-8 — no line endings normalized, no metadata
// removed — written sha256:<lower-hex>. An author signature covers the authored digest, a delivery signature the
// delivered text's. Isomorphic (browser + node): @noble/hashes, no node:crypto.
import { sha256 } from "@noble/hashes/sha256";
import { bytesToHex } from "@noble/hashes/utils";

const enc = new TextEncoder();

export function sha256Hex(bytes: Uint8Array | string): string {
  return bytesToHex(sha256(typeof bytes === "string" ? enc.encode(bytes) : bytes));
}

/** The authored digest of a document: its stored text, byte for byte. */
export function digest(text: string): string {
  return `sha256:${sha256Hex(text)}`;
}

/** Digest of arbitrary text (delivered bytes, values, sources). */
export function digestText(text: string): string {
  return `sha256:${sha256Hex(text)}`;
}
